export default [
	{
		name: 'Name',
		field: 'name',
		width: 'large'
	},
	{
		name: 'Address',
		field: 'address1',
		width: 'large'
	},
	{
		name: 'Phone',
		field: 'phone',
		width: 'large'
	},
	{
		name: 'Zip',
		field: 'postal_code',
		width: 'large'
	},
]



/** WEBPACK FOOTER **
 ** ./src/tables/vendors.js
 **/